import { Component, OnInit } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-asahome',
  templateUrl: './asahome.component.html',
  styleUrls: ['./asahome.component.scss']
})
export class AsahomeComponent implements OnInit {

  constructor(private meta: Meta,
              private titles: Title) { }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('Bachelors in Agriculture at ARNI School of Agriculture');
        this.meta.updateTag({
            name: 'description',
            content: `Pursue a bachelors in agriculture at ARNI School of Agriculture. Gain practical knowledge and skills for a successful career in the agriculture sector.`
        });
    }

}
